import { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import { ref, runTransaction } from "firebase/database";
import { auth, db } from "../config/firebase.js";

const SoloAuthContext = createContext(null);

export function SoloAuthProvider({ children }) {
  const [googleUser, setGoogleUser] = useState(null);
  const [carregandoAuth, setCarregandoAuth] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(auth, async (user) => {
        const isGoogle = user?.providerData?.some(
          (provider) => provider.providerId === "google.com",
        );
        setGoogleUser(isGoogle ? user : null);
        setCarregandoAuth(false);

        if (isGoogle) {
          try {
            await runTransaction(
              ref(db, `googleUsers/${user.uid}`),
              (atual) => (atual === true ? undefined : true),
              { applyLocally: false },
            );
          } catch (error) {
            console.error(
              "Erro ao registrar usuário Google no contador:",
              error,
            );
          }
        }
      }),
    [],
  );

  const value = useMemo(
    () => ({
      googleUser,
      carregandoAuth,
      entrarComGoogle: async () => {
        try {
          await signInWithPopup(auth, new GoogleAuthProvider());
        } catch (error) {
          console.error("Erro ao entrar com Google:", error);
        }
      },
      sairDoGoogle: async () => {
        try {
          await signOut(auth);
        } catch (error) {
          console.error("Erro ao sair:", error);
        }
      },
    }),
    [googleUser, carregandoAuth],
  );

  return (
    <SoloAuthContext.Provider value={value}>
      {children}
    </SoloAuthContext.Provider>
  );
}

export function useSoloAuth() {
  const context = useContext(SoloAuthContext);
  if (!context) {
    throw new Error("useSoloAuth deve ser usado dentro de SoloAuthProvider");
  }
  return context;
}

export function GoogleAccountButton({ local = "jogo" }) {
  const { googleUser, carregandoAuth, entrarComGoogle, sairDoGoogle } =
    useSoloAuth();
  const inicio = local === "inicio";

  if (carregandoAuth) return null;

  if (!googleUser) {
    return (
      <button
        className="google-account-button"
        onClick={entrarComGoogle}
        type="button"
      >
        {inicio
          ? "🔑 Entrar com Google"
          : "🔑 Entrar com Google (pra entrar no Ranking)"}
      </button>
    );
  }

  return (
    <div className="google-account-connected">
      {googleUser.photoURL && (
        <img
          src={googleUser.photoURL}
          alt={googleUser.displayName || "Conta Google"}
          width="28"
          height="28"
        />
      )}
      <span>
        {inicio ? "Conta conectada: " : "Jogando como "}
        <strong>{googleUser.displayName}</strong>
      </span>
      <button onClick={sairDoGoogle} type="button">
        Sair
      </button>
    </div>
  );
}
